import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { addAddress, getAddresses } from '../../../api/ans';
import cancelicon from '../../../assets/images/cancelIcon.svg';
import { openSelectAddres, setAddresList } from '../../../store/slices/ordersSlice';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppSelector } from '../../../store/store';
import { elevatorTypeOptions } from '../../../utils/constants';
import useSubmitLock from '../../../utils/useSubmitLock';
import RedButton from '../../ui/buttons/redButton/RedButton';
import ElevatorSelector from '../../ui/elevatorSelector/ElevatorSelector';
import FormInput from '../../ui/formInput/FormInput';
import styles from './styles/styles.module.css';

function AddAdressPopup() {
  const user = useAppSelector((state) => state.user.data);
  const dispatch = useDispatch();
  const methods = useForm({});
  // const onBack = useAppSelector((state) => state.popup.popupProps.backButton);
  const isSelect = useAppSelector((state) => state.popup.popupProps.isSelect);
  const { handleSubmit } = methods;
  const { isSubmitting, run } = useSubmitLock();

  const submitAddress = (data) => {
    console.log(data);
    return addAddress({
      phone: user.phone,
      ...data,
    })
      .then(() => {
        if (isSelect) {
          dispatch(openSelectAddres(true));
        }
        dispatch(closePopup());
        getAddresses().then((addressData) => {
          dispatch(setAddresList(addressData));
        });
      })
      .catch(() => {
        dispatch(
          openPopup({
            name: 'error',
            props: {
              errorTitle: 'Добавить адрес не удалось!',
              errorText: 'Попробовать снова',
              errorParagraph: 'Попробуйте добавить адрес позже',
              buttonText: 'Попробовать снова',
            },
          })
        );
      });
  };

  const onSubmit = (data) => run(() => submitAddress(data));

  return (
    <div className={styles.addAdressWrapper}>
      <div className={styles.AddClc}>
        <h1 className={styles.headerAddAdress}>Адрес доставки</h1>
        <img
          src={cancelicon}
          onClick={() => {
            dispatch(closePopup());
          }}
        />
      </div>
      <FormProvider {...methods}>
        <form className={styles.AddForm} onSubmit={handleSubmit(onSubmit)}>
          <div>
            <FormInput
              label="Адрес"
              placeholderText=""
              inputName="full_address"
              validationRules={{
                required: true,
                minLength: {
                  value: 3,
                  message: 'Не менее 3 знаков',
                },
                validate: (value) => {
                  if (!value) return true;

                  const hasHouse =
                    /,\s*(д\.?|дом)\s*\d+/i.test(value) ||
                    /,\s*\d+[а-яa-z]?/i.test(value) ||
                    /,\s*(кв\.?|квартира)\s*\d+/i.test(value);

                  return hasHouse || 'Выберите адрес из списка и укажите номер дома';
                },
              }}
            />
          </div>
          <div className={styles.AddHome}>
            <FormInput label="Подъезд" inputName="entrance" inputType="number" />
            <FormInput
              label="Этаж"
              inputName="floor"
              inputType="number"
              validationRules={{
                min: {
                  value: -10,
                  message: 'Этаж не может быть меньше -10',
                },
                max: {
                  value: 200,
                  message: 'Этаж не может быть больше 200',
                },
              }}
            />
          </div>
          <div className={styles.AddUpward}>
            <FormInput label="Домофон" placeholderText="" inputName="intercom" />
            <div>
              <ElevatorSelector
                label="Лифт"
                name="elevator_type"
                options={elevatorTypeOptions}
                placeholder=""
              />
            </div>
          </div>
          <div className={styles.addComment}>
            <FormInput
              label="Уточнение адреса"
              inputName="comment"
              placeholderText="Комментарии к адресу для курьера"
              isTextarea
            />
          </div>
          <div>
            <RedButton text="Добавить адрес" height={56} disabled={isSubmitting} />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

export default AddAdressPopup;
